import client from '@/plugins/axios.js'

export default  {
  postList(typeId){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/post/dashboardPosts/' + typeId)
        .then((res)=>{
          resolve(res.data.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },
  
  oldApipostList(typeId){
    return new Promise((resolve,reject)=>{
      /*client({requiresAuth:true}).get('/api/product/products')
        .then((res)=>{
        resolve(res.data.data)
        })
        .catch((err)=>{
        reject(err)
        })*/
      let testUrl = `https://admin.perfecthome.no/api.php/posts/intranet?types=${typeId}&limit=3&ph_lang=NO&ph_country=1`
      fetch(testUrl)
        .then((response) => response.text())
        .then((res) => {
          resolve(JSON.parse(res.trim()))
        })
        .catch((err) => {
          reject(err)
        })
      
      
      
    });
  },
  
  
  
}
